// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"217":"1742ae72","383":"916d8bd9","869":"9bcfba99"}[chunkId] + ".js";
};